module.exports = __webpack_public_path__ + "static/media/program-12.b15605b5.webp";